// Stub — direct AI calls (fallback when backend /api/ai/complete/ is unavailable).
// The backend endpoint is the primary path; this is only reached if it fails.

export class AiError extends Error {
  constructor(message, { status } = {}) {
    super(message);
    this.name = 'AiError';
    this.status = status;
  }
}

/**
 * Minimal fallback: calls the backend endpoint directly.
 * A real per-user-key implementation would POST to the AI provider.
 */
export async function complete({ system, user, maxTokens = 800 } = {}) {
  throw new AiError('Per-user AI key fallback not configured on this deployment.');
}
